// extracted by mini-css-extract-plugin
export default {"productGrid":"L0-z","centerLink":"M0-z","productSection":"N0-z","item":"O0-z","ctaButton":"P0-z"};